import { render, staticRenderFns } from "./NoneOffers.vue?vue&type=template&id=128a620c"
import script from "./NoneOffers.vue?vue&type=script&setup=true&lang=ts"
export * from "./NoneOffers.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports